export const getYouTubeVideoId = (url: string) => {
  return url.split('https://youtu.be/')[1];
};
